import React from "react";

import { Typography, Box } from "@mui/material";

import { LucideMaximize2 } from "lucide-react";

import { ListCard } from "@/components/Luna/features";
import useLesson from "@/contexts/useLesson";
import { Diagram } from "@/types";

interface Props {
  diagram: Diagram;
  index: number;
  onApprove: (index: number) => void;
  onRegenerate: (index: number) => void;
  onOpenModal: (diagram: Diagram) => void;
  onDelete: (index: number) => void;
}

const DiagramItem: React.FC<Props> = ({
  diagram,
  index,
  onApprove,
  onRegenerate,
  onOpenModal,
  onDelete,
}) => {
  const { lessonResourceState } = useLesson();
  const isRead = lessonResourceState?.readItems?.includes(diagram.id);

  return (
    <ListCard
      title={`${index + 1}. ${diagram.title}`}
      isApproved={diagram.isApproved}
      onApprove={onApprove}
      onRegenerate={onRegenerate}
      index={index}
      onOpenModal={() => onOpenModal(diagram)}
      onDelete={() => onDelete(index)}
      id={diagram.id}
      isRead={isRead}
    >
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ mb: 1 }}
        onClick={(e) => {
          e.stopPropagation();
          onOpenModal(diagram);
        }}
      >
        {diagram.description.substring(0, 250)}
        {diagram.description.length > 250 ? (
          <span className="text-gray-500">...</span>
        ) : (
          ""
        )}
      </Typography>
      <Box sx={{
 position: "relative",
mt: 2 
}}>
        <img
          src={diagram.imageUrl}
          alt={diagram.title}
          style={{
 width: "100%",
height: "auto" 
}}
        />
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            opacity: 0,
            "&:hover": { opacity: 0.4 },
            transition: "opacity 0.3s",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
          }}
          onClick={() => onOpenModal(diagram)}
        >
          <LucideMaximize2 className="w-6 h-6 text-white mr-2" />
        </Box>
      </Box>
    </ListCard>
  );
};

export default DiagramItem;
